export default "__VITE_ASSET__D4dodj2n__"